// extracted by mini-css-extract-plugin
module.exports = {"container":"DeliveryRequestUpdateModal_container_Nb0Xv","actions":"DeliveryRequestUpdateModal_actions_3JY0F","right":"DeliveryRequestUpdateModal_right_56Rgj"};